document.addEventListener('DOMContentLoaded', () => {

  const contents = document.querySelectorAll('.seo-kollektionstext-inner');

  contents.forEach(content => {

    const btn = content.closest('.seo-kollektionstext-wrapper')?.querySelector('.seo-toggle-btn');
    if (!btn) return;

    const moreText = btn.getAttribute('data-more');
    const lessText = btn.getAttribute('data-less');

    const collapsedHeight = window.innerWidth < 750 ? 490 : 470;

    if (content.scrollHeight <= collapsedHeight) {
      content.classList.add('open');
      content.style.maxHeight = 'none';
      btn.style.display = 'none';
      return;
    }

    content.style.maxHeight = collapsedHeight + 'px';

    btn.addEventListener('click', () => {
      const isOpen = content.classList.contains('open');

      if (!isOpen) {
        // expand
        content.classList.add('open');
        content.style.maxHeight = content.scrollHeight + 'px';
        btn.textContent = lessText;
        btn.setAttribute('aria-expanded', 'true');
      } else {
        // collapse
        content.style.maxHeight = content.scrollHeight + 'px';
        void content.offsetHeight; // Reflow
        content.classList.remove('open');
        content.style.maxHeight = collapsedHeight + 'px';
        btn.textContent = moreText;
        btn.setAttribute('aria-expanded', 'false');
      }
    });
  });
});